export default __webpack_public_path__ + "static/media/Group 74.5183c12a.svg";